<template>
  <div class="icon-link-slider">
    <v-carousel
      :continuous="false"
      :cycle="cycle"
      height="auto"
      :show-arrows="false"
      :delimiter-icon="circleImage"
      :interval="interval"
      hide-delimiter-background
    >
      <v-carousel-item v-for="(slide, i) in slides" :key="i">
        <div class="icon-link-banner">
          <div
            v-for="item in slide.slideContent"
            :key="item.index"
            class="link-item"
          >
            <div class="item-icon" @click="toCuration(item.curationGuid)">
              <div class="item-icon__image">
                <img
                  :src="item.imagePath"
                  :alt="item.title"
                  onerror="this.src = '../assets/img/placholder_512.svg';"
                />
              </div>
            </div>
            <div class="item-icon__title">{{ item.title }}</div>
          </div>
        </div>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
export default {
  name: 'IconLinkSlider',
  props: {
    iconLinks: {
      type: Array,
      default: () => [],
    },
    cycle: {
      type: Boolean,
      default: false,
    },
    interval: {
      type: Number,
      default: 7000,
    },
  },
  data: () => ({
    slides: [],
    circleImage: require('@/assets/img/icon/simple-circle_gray.svg'),
  }),
  methods: {
    toCuration(id) {
      gtag('event', 'click', {
        event_id: '009',
        location: '首頁',
        event_category: '策展--群組',
        event_label: id,
        value: 9,
      })
      this.$router.push({
        name: 'curation',
        params: { id: id },
      })
    },
  },
  created() {
    this.iconLinks.forEach((item, index) => {
      if (index % 6 === 0) {
        this.slides.push({
          index: this.slides.length,
          slideContent: [],
        })
      }
      this.slides[this.slides.length - 1].slideContent.push(item)
    })
  },
}
</script>

<style lang="scss" scoped>
.icon-link-slider {
  border-radius: 8px;
  .icon-link-banner {
    display: flex;
    background-color: #f3f5f8;
    width: 100%;
    height: 223px;
    padding: 20px;
    position: relative;
    flex-wrap: wrap;

    .link-item {
      text-align: center;
      display: inline-block;
      width: 33.3333%;
      margin-bottom: 20px;

      .item-icon {
        text-align: center;
        width: 84px;
        margin: 0 auto 5px auto;

        &__image {
          display: flex;
          justify-content: center;
          align-items: center;
          background: white;
          height: 50px;
          width: 50px;
          border-radius: 1000px;
          margin: auto;
          overflow: hidden;
          background: url('../assets/img/placholder_512.svg');
          background-size: contain;
          img {
            width: 100%;
          }
        }

        &__title {
          // width: 84px;
          text-align: center;
          margin: auto;
          font-size: 14px;
          letter-spacing: 0.44px;
          text-align: center;
          color: #383838;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }

  ::v-deep .v-carousel {
    border-radius: 16px;
    z-index: 0;
    .v-carousel__controls {
      height: 25px;
      .v-item-group {
        .v-carousel__controls__item.v-btn {
          margin: 0 5px 0 0;
          width: 5px;
          height: 5px;
          background: #bbbbbb;
          opacity: 1;

          &.v-btn--active {
            background: #767676;
          }

          &::before {
            opacity: 0;
          }
        }
      }
    }
  }
}
</style>
